import React from "react";

import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import ListItem from "@mui/material/ListItem";

import {
  PLACE_TYPE_NAME_CHOISE,
  PLACE_TYPE_COLOR_CHOISE,
} from "../../constans";

const Wrapper = styled(ListItem)(() => ({
  width: "auto",
  padding: 0,
}));

const StyledLink = styled(Box)(({ active, color }) => ({
  display: "block",
  fontFamily: "Proxima Nova",
  fontWeight: active !== "false" ? "bold" : 400,
  fontSize: "16px",
  lineHeight: 1.187,
  marginBottom: "22px",
  color: "#1a1a1a",
  whiteSpace: "nowrap",
  cursor: "pointer",
  ...(active !== "false"
    ? {
        marginBottom: 0,
        "&::after": {
          content: `" "`,
          display: "block",
          height: "4px",
          backgroundColor: color,
          marginTop: "18px",
        },
      }
    : null),
}));

const NavbarLinks = ({
  place,
  currentLink,
  scrollToSection,
  setCurrentLink,
}) => {
  return (
    <Wrapper>
      <StyledLink
        active={Boolean(place === currentLink).toString()}
        color={PLACE_TYPE_COLOR_CHOISE[place]}
        onClick={() => {
          scrollToSection(place);
          setCurrentLink(place);
        }}
      >
        {PLACE_TYPE_NAME_CHOISE[place]}
      </StyledLink>
    </Wrapper>
  );
};

export default NavbarLinks;
